import request from "@/util/request";
export function getSysConf(saasId) {
    return request({
        url: '/saas/application/conf',
        method: 'get',
        params:{id:saasId}
    })
}
